import React from "react";
import {
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter
} from "reactstrap";

const ErrorModal = ({ modal, setModal, goEdit }) => {
    return (
        <Modal isOpen={modal} toggle={() => setModal(false)}>
            <ModalHeader>
                Alert
              </ModalHeader>
            <ModalBody>
                Careful you've changed new data on Sheet, you can edit template sheet.
              </ModalBody>
            <ModalFooter className="d-flex justify-content-between">
                <button
                    className="btn btn-light px-3"
                    onClick={() => setModal(false)}
                >
                    Ignore
                </button>
                <button
                    className="btn btn-primary"
                    onClick={goEdit}
                >
                    Edit Inventory
                </button>
            </ModalFooter>
        </Modal>
    )
}

export default ErrorModal